import React, { useState } from "react";
import { useQuery } from "@tanstack/react-query";
import api from "@/lib/api";
import { fmtEuro, fmtDate, RUN_TYPE_LABEL } from "@/lib/format";
import { useAuth } from "@/context/AuthContext";
import PayslipModal from "@/components/PayslipModal";
import { FileText } from "lucide-react";

export default function Payslips() {
  const { user } = useAuth();
  const [open, setOpen] = useState(null);
  const { data = [], isLoading } = useQuery({
    queryKey: ["my-payslips"],
    queryFn: async () => (await api.get("/my/payslips")).data,
  });

  return (
    <div className="space-y-6" data-testid="payslips-page">
      <div>
        <p className="text-xs font-mono uppercase tracking-widest text-[#C86235]">Προσωπικά</p>
        <h1 className="font-serif text-3xl md:text-4xl text-[#45423C] mt-1">Οι Αποδείξεις μου</h1>
        <p className="text-[#6F6A60] text-sm mt-1">
          {user?.employee_name ? `Συνδεδεμένο με το προφίλ: ${user.employee_name}` : "Δεν έχει συνδεθεί προφίλ υπαλλήλου στον λογαριασμό σας."}
        </p>
      </div>

      {isLoading ? (
        <div className="text-[#6F6A60] py-10 text-center">Φόρτωση…</div>
      ) : data.length === 0 ? (
        <div className="rounded-2xl bg-white border border-[#E3DED4] p-10 text-center text-[#6F6A60]">
          Δεν βρέθηκαν αποδείξεις για τον λογαριασμό σας.
        </div>
      ) : (
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
          {data.map((p, i) => (
            <button
              key={p.id ?? `${p.run_type}-${p.year}-${p.month}-${i}`}
              data-testid={`payslip-card-${i}`}
              onClick={() => setOpen(p)}
              className="text-left rounded-2xl bg-white border border-[#E3DED4] p-5 hover:border-[#B9AE9A] hover:shadow-sm transition-all"
            >
              <div className="flex items-center justify-between">
                <span className="px-2.5 py-1 rounded-full bg-[#EEF0EA] text-[#6E7A63] text-[10px] font-semibold uppercase tracking-wider">
                  {RUN_TYPE_LABEL[p.run_type] || p.run_type}
                </span>
                <FileText className="h-4 w-4 text-[#C86235]" />
              </div>
              <div className="font-serif text-lg text-[#45423C] mt-3">{p.label_el || p.label_en}</div>
              <div className="text-xs text-[#6F6A60]">{fmtDate(p.period_end)}</div>
              <div className="mt-4 pt-4 border-t border-[#E3DED4] flex items-end justify-between">
                <div>
                  <div className="text-[10px] uppercase tracking-wider text-[#6F6A60]">Σύνολο</div>
                  <div className="font-serif text-lg text-[#45423C] tabular">{fmtEuro(p.item.total_earnings)}</div>
                </div>
                <div className="text-right">
                  <div className="text-[10px] uppercase tracking-wider text-[#6F6A60]">Υπόλοιπο</div>
                  <div className="font-medium text-[#6E7A63] tabular">{fmtEuro(p.item.remaining)}</div>
                </div>
              </div>
            </button>
          ))}
        </div>
      )}

      {open && <PayslipModal item={open.item} run={open} onClose={() => setOpen(null)} />}
    </div>
  );
}
